import {
  Button,
  IconAdd20,
} from '@lightspeed/unified-components-helios-theme/react'
import React from 'react'
import { HEAP_DATA_TRACK_ADD_ADDRESS } from '../../../../sale-model.constant'
import { AddOrEditAddressButton } from '../EditAddressButton'
import { EmptyAddressProps, useEmptyAddressModel } from './useEmptyAddressModel'

export const EmptyAddress: React.FC<EmptyAddressProps> = props => {
  const model = useEmptyAddressModel(props)

  return (
    <div className="uc-base">
      <div className="flex flex-col items-start gap-3">
        <p className="typography-body-sm-emphasized">{model.title}</p>
        {model.shouldOpenFulfilmentPopover ? (
          <Button
            appearance="ghost"
            customDataAttributes={{
              container: { 'data-track': HEAP_DATA_TRACK_ADD_ADDRESS },
            }}
            onClick={model.openFulfillmentPopover}
            prefixSlot={<IconAdd20 aria-hidden />}
            size="medium"
            type="button"
          >
            {model.addAddressLabel}
          </Button>
        ) : (
          <AddOrEditAddressButton
            type={model.buttonType}
            isModalOpeningOnError={props.isModalOpeningOnError}
            hasError={props.hasError}
            lineItemLocalId={props.lineItemLocalId}
            onSave={props.onSave}
            onOpenModal={model.openAddressModal}
          />
        )}
      </div>
    </div>
  )
}
